import '../../sass/template-parts/checkout-step-3.scss';

import Pristine from 'pristinejs';

(() => {
    const $form = document.querySelector('.newsletter__form');
    const $turnstile = $form?.querySelector('.newsletter__turnstile');
    const $turnstileToken = $form?.querySelector('.newsletter__turnstile-token');

    let pristine = null;

    const checkIfTurnstileReady = resolve => {
        const interval = setInterval(() => {
            if (!$turnstileToken.value) return;

            resolve(interval);
            clearInterval(interval);
        }, 100);
    };

    const initNewsletter = () => {
        if (!$form) return;

        $form.addEventListener('submit', e => {
            if ($form.classList.contains('newsletter__form--loading')) return;

            e.preventDefault();

            pristine = new Pristine($form);

            $form.classList.add('newsletter__form--loading');

            if (!pristine.validate()) {
                $form.classList.remove('newsletter__form--loading');
                return;
            }

            if ($turnstile) {
                const waitUntilReady = new Promise(checkIfTurnstileReady);

                waitUntilReady.then(() => {
                    $form.submit();
                });
            } else {
                $form.submit();
            }
        });
    };

    if (typeof turnstile !== 'undefined') {
        turnstile.render($turnstile, {
            sitekey: $turnstile?.dataset?.sitekey,
            callback: id => {
                $turnstileToken.value = id;
            }
        });
    } else {
        window.onloadTurnstileCallback = () => {
            if (!$turnstile) return;

            turnstile.render($turnstile, {
                sitekey: $turnstile?.dataset?.sitekey,
                callback: id => {
                    $turnstileToken.value = id;
                }
            });
        };
    }

    initNewsletter();
})();
